<template>
  <section class="aso-senha-step">
    <h2 class="aso-senha-step__title">Crie sua Senha.</h2>
    <p class="aso-senha-step__text"><strong>Seu e-mail será utilizado como login de acesso.</strong> Crie uma senha segura com ao menos 8 caracteres, incluindo letra maiúscula, minúscula, número e caractere especial.</p>

    <input
      class="aso-senha-step__input"
      type="password"
      :value="password"
      placeholder="Digite a senha"
      :disabled="busy"
      @input="$emit('update:password', $event.target.value)"
    >

    <input
      class="aso-senha-step__input"
      type="password"
      :value="passwordConfirm"
      placeholder="Repita a senha"
      :disabled="busy"
      @input="$emit('update:passwordConfirm', $event.target.value)"
      @blur="$emit('confirm-blur')"
    >

    <p v-if="passwordError" class="aso-senha-step__error">{{ passwordError }}</p>

    <button
      type="button"
      class="aso-senha-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full"
      :disabled="busy"
      @click="$emit('continue')"
    >
      {{ busy ? 'Salvando...' : 'Continuar' }}
    </button>
  </section>
</template>

<script>
export default {
  name: 'AsoValidarSenhaStep',
  props: {
    password: {
      type: String,
      default: '',
    },
    passwordConfirm: {
      type: String,
      default: '',
    },
    passwordError: {
      type: String,
      default: '',
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
}
</script>



// WEBPACK FOOTER //
// AsoValidarSenhaStep.vue?7dfb7c6a